import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Card } from '@wartek-id/card'
import { Button } from '@wartek-id/button-v1'

import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { assetUrl } from 'utils/url'
import { PENGELOLAAN_KINERJA_KADIN_PEMBERI_PREDIKAT_PATH } from 'app/KinerjaShared/constants/path'

import type { FC } from 'react'

interface KinerjaDinasPemberiPredikatKinerjaOrganisasiIndexProps {}

const KinerjaDinasPemberiPredikatKinerjaOrganisasiIndex: FC<
  KinerjaDinasPemberiPredikatKinerjaOrganisasiIndexProps
> = ({}) => {
  const { periodYear, periodNo } = usePeriodContext()

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu="kadin-pemberi-predikat" />
      <div className="m-6">
        <Card>
          <div className="flex flex-col gap-6 w-full">
            <section className="flex space-x-6 p-6 items-start  rounded">
              <div className="flex-shrink-0">
                <img
                  alt=""
                  src={assetUrl('/illustrations/img-post-mail.png')}
                  width={84}
                  height={84}
                />
              </div>

              <div className="space-y-1 max-w-2xl">
                <Text variant="subheading" className="!text-blue-60 uppercase">
                  {periodNo === 1
                    ? '1 Januari - 30 Juni '
                    : '1 Juli - 31 Desember '}
                  {periodYear}
                </Text>
                <Text variant="heading-lg">
                  Kirim Predikat Kinerja Organisasi
                </Text>
                <Text color="subdued">
                  Segera cek dan kirim agar Kepala Sekolah dapat memulai
                  Penetapan Predikat Kinerja untuk guru-gurunya.
                </Text>
                <Link
                  passHref
                  href={`${PENGELOLAAN_KINERJA_KADIN_PEMBERI_PREDIKAT_PATH}/kirim`}
                >
                  <Button
                    color="blue"
                    className="!mt-3.5 !inline-flex"
                    size="lg"
                    type={undefined}
                    as="a"
                  >
                    Cek
                  </Button>
                </Link>
              </div>
            </section>
          </div>
        </Card>
      </div>
    </div>
  )
}
export default KinerjaDinasPemberiPredikatKinerjaOrganisasiIndex
